// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Addresses = (await import('./pages/Addresses')).Addresses;
    Components.AddCreditCard = (
      await import('./pages/Add-Credit-Card')
    ).AddCreditCard;
    Components.InstantCheckout = (
      await import('./pages/Instant-Checkout')
    ).InstantCheckout;
    Components.HDWalletAuth = (
      await import('./pages/HDWalletAuth')
    ).HDWalletAuth;
    Components.RemotePurchasesPage = (
      await import('./pages/Remote-Purchases-Perf')
    ).RemotePurchasesPage;
    Components.BulkAddCreditCards = (
      await import('./pages/Bulk-Add-Credit-Cards')
    ).BulkAddCreditCards;
    Components.AddGiftCard = (
      await import('./pages/Add-Gift-Card')
    ).AddGiftCard;
    Components.Payments = (await import('./pages/Payments')).Payments;
  }
  return Components;
};

export const getRoutes = (
  currentRouteName,
  currentRouteComponent,
  serverPages,
) => ({
  addresses: {
    name: 'Addresses',
    componentName: 'Addresses',
    chunk: () => import('./pages/Addresses'),
    get component() {
      return ssr
        ? serverPages.Addresses
        : currentRouteName === 'Addresses'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.Addresses,
              })),
            );
    },
    path: '/:context?/myaccount/addresses',
    channel: null,
  },
  addCreditCard: {
    name: 'AddCreditCard',
    componentName: 'AddCreditCard',
    chunk: () => import('./pages/Add-Credit-Card'),
    get component() {
      return ssr
        ? serverPages.AddCreditCard
        : currentRouteName === 'AddCreditCard'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.AddCreditCard,
              })),
            );
    },
    path: '/:context?/myaccount/payments/addcreditcard',
    channel: null,
  },
  instantCheckout: {
    name: 'InstantCheckout',
    componentName: 'InstantCheckout',
    chunk: () => import('./pages/Instant-Checkout'),
    get component() {
      return ssr
        ? serverPages.InstantCheckout
        : currentRouteName === 'InstantCheckout'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.InstantCheckout,
              })),
            );
    },
    path: '/:context?/myaccount/payments/instant-checkout',
    channel: null,
  },
  enrollHDWalletFromNativeApp: {
    name: 'HDWalletAuth',
    componentName: 'HDWalletAuth',
    chunk: () => import('./pages/HDWalletAuth'),
    get component() {
      return ssr
        ? serverPages.HDWalletAuth
        : currentRouteName === 'HDWalletAuth'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.HDWalletAuth,
              })),
            );
    },
    path: '/:context?/myaccount/payments/authorizehdwallet',
    channel: null,
  },
  remotePurchasesPerfTest: {
    name: 'RemotePurchasesPage',
    componentName: 'RemotePurchasesPage',
    chunk: () => import('./pages/Remote-Purchases-Perf'),
    get component() {
      return ssr
        ? serverPages.RemotePurchasesPage
        : currentRouteName === 'RemotePurchasesPage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.RemotePurchasesPage,
              })),
            );
    },
    path: '/:context?/myaccount/payments/remote-purchases-perf-test',
    channel: null,
  },
  bulkAddCreditCards: {
    name: 'BulkAddCreditCards',
    componentName: 'BulkAddCreditCards',
    chunk: () => import('./pages/Bulk-Add-Credit-Cards'),
    get component() {
      return ssr
        ? serverPages.BulkAddCreditCards
        : currentRouteName === 'BulkAddCreditCards'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.BulkAddCreditCards,
              })),
            );
    },
    path: '/:context?/myaccount/payments/bulkaddcreditcards',
    channel: null,
  },
  addGiftCard: {
    name: 'AddGiftCard',
    componentName: 'AddGiftCard',
    chunk: () => import('./pages/Add-Gift-Card'),
    get component() {
      return ssr
        ? serverPages.AddGiftCard
        : currentRouteName === 'AddGiftCard'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.AddGiftCard,
              })),
            );
    },
    path: '/:context?/myaccount/payments/addgiftcard',
    channel: null,
  },
  payments: {
    name: 'Payments',
    componentName: 'Payments',
    chunk: () => import('./pages/Payments'),
    get component() {
      return ssr
        ? serverPages.Payments
        : currentRouteName === 'Payments'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.Payments,
              })),
            );
    },
    path: '/:context?/myaccount/payments',
    channel: null,
  },
});
